module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00186.75a9a41d.jpg";